/* src/app/shared/components/ngx-responsive-table/freeze-first-column.scss */
@media screen and (min-width: 600px) {
  .ngx-responsive-table.freeze-first-column {
    padding-left: 10rem;
    position: relative;
  }
  .ngx-responsive-table.freeze-first-column .table-wrapper {
    overflow: auto;
  }
  .ngx-responsive-table.freeze-first-column ::ng-deep table thead tr th:first-of-type,
  .ngx-responsive-table.freeze-first-column ::ng-deep table tbody tr td:first-of-type {
    position: absolute;
    left: 0;
    top: auto;
    width: 10rem;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    box-shadow: 1px 0 0 0 rgba(0, 0, 0, 0.12);
  }
  .ngx-responsive-table.freeze-first-column ::ng-deep table thead tr th:first-of-type {
    background-color: #d9d9d6;
  }
  .ngx-responsive-table.freeze-first-column ::ng-deep table tbody tr:nth-child(even) td {
    background-color: #f4f4f4;
  }
}
/*# sourceMappingURL=freeze-first-column.css.map */
